import { render, staticRenderFns } from "./LichSuDichVuVanTaiKhachList.vue?vue&type=template&id=7d0d8642"
import script from "./LichSuDichVuVanTaiKhachList.vue?vue&type=script&lang=js"
export * from "./LichSuDichVuVanTaiKhachList.vue?vue&type=script&lang=js"
import style0 from "./LichSuDichVuVanTaiKhachList.vue?vue&type=style&index=0&id=7d0d8642&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports